// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kt-0";
export var buttonContainer = "_kt-3";
export var cancelButton = "_kt-4";
export var headerSection = "_kt-6";
export var headerTitle = "_kt-9";
export var messageSideLeft = "_kt-1";
export var messageSideRight = "_kt-2";
export var orderNumberContainer = "_kt-7";
export var orderNumberLabel = "_kt-8";
export var submitButton = "_kt-5";